import { render, staticRenderFns } from "./BetButtonInverse.vue?vue&type=template&id=2e0f9beb&"
import script from "./BetButtonInverse.vue?vue&type=script&lang=js&"
export * from "./BetButtonInverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports